export default __webpack_public_path__ + "static/urakawa-f3b354f487688cc15c5e3e8d77e08a18.jpg";